import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            深度策划的漫画专题内容
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {carouselData.slice(0, 3).map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-900/40 to-transparent"></div>
                  <span className="absolute bottom-3 left-3 px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {carouselData.slice(3, 5).map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex flex-col sm:flex-row bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative sm:w-56 aspect-[16/9] sm:aspect-auto overflow-hidden shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute bottom-2 left-2 px-2 py-0.5 text-xs font-semibold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5 flex-1 flex flex-col justify-center">
                  <h3 className="text-lg font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}